import { recaptchaUpdater } from '../../modules/recaptcha';
import { unity, stores, funcional, area, cdType, stateCity } from '../../modules/select';
import Swal from 'sweetalert2';

const bindActions = () => {
  $('#form-signin').on('submit', function (e) {
    e.preventDefault();

    let checkLength = $('.js-check').length;

    if ($('.js-check:checked').length !== checkLength) {
      Swal.fire('Você deve aceitar os termos para continuar!', '', 'error');
      return false;
    } else {
      e.target.submit();
    }
  });
};

export const profilesTerms = () => {
  bindActions();
  unity();
  stores();
  funcional();
  area();
  cdType();
  stateCity();
  recaptchaUpdater('profile');
};
